import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import { actionType, modalActionType } from 'utils/constants';
import IntlHelper from 'utils/helpers/intl.helper';
import useCheckBeforeAction from '../hooks';

interface Props {
  disabled?: boolean;
}

const ReverseRepostButton = (props: Props) => {
  const { disabled } = props;
  const dispatch = useDispatch();
  const t = IntlHelper.useTranslator();
  const activeDocuments = useSelector(selectors.documents.selectAllActiveDocuments);
  const idProgram = useSelector(selectors.app.getProgramCode);
  const { checkDocuments } = useCheckBeforeAction(actionType.REVERSE_REPOST);
  return (
    <CommonButton
      id="reverse-repost-action"
      action={async () => {
        const docFree = await checkDocuments();
        if (!docFree) return;
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.documents.REVERSE_REPOST,
            props: {
              idProtocol: activeDocuments[0].protocol,
              idUser: activeDocuments[0].idUser,
              idProgram,
              automaticDistribute: activeDocuments[0].exportStatus === 3,
            },
          }),
        );
      }}
      scope="tertiary"
      value={t('reverse-repost')}
      customIcon="revert-flux"
      disabled={disabled}
    />
  );
};

export default ReverseRepostButton;
